import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useSessionStorage from '../hooks/useSessionStorage';
import KustomReceipt from './Payments/KustomReceipt';

function Label({ name, value }) {
  return (
    <p className="order-details">
      <b>{name}</b>
      <br /> {value}
    </p>
  );
}

function Receipt({ clubData, receiptData }) {
  const { t } = useTranslation();

  const [, setOrderData] = useSessionStorage('order-data', null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setOrderData(null);
  }, []);

  const reloadPage = () => {
    window.top.location.href = clubData.parentUrl;
  };

  return (
    <div className="content">
      {receiptData?.html_snippet && <KustomReceipt htmlSnippet={receiptData.html_snippet} />}
      <h2>{t('thanks')}</h2>
      <p>{clubData.thanksText || t('thanksDel')}</p>
      <h4>{t('yourOrder')}</h4>
      <div style={{ marginTop: 20 }}>
        <Label name={t('orderNumber')} value={receiptData.order_id} />
        <Label name={t('product')} value={`${receiptData.number} x ${receiptData.product_name}`} />
        <Label name={t('price')} value={`${receiptData.total_price} ${receiptData.currency}`} />
        <Label name={t('name')} value={`${receiptData.firstname} ${receiptData.lastname}`} />
        {receiptData.address && (
          <Label name={t('address')} value={`${receiptData.address}, ${receiptData.postAddress}`} />
        )}
        <Label name={t('email')} value={receiptData.email} />
        <Label name={t('mobile')} value={receiptData.mobile} />
        <Label
          name={t('delivery')}
          value={t(`deliveryOpt${receiptData.delivery.charAt(0).toUpperCase() + receiptData.delivery.slice(1)}`)}
        />
        {/* <Label name="Betalning" value={receiptData.payment} /> */}
      </div>
      <button type="button" className="button" style={{ marginTop: 20 }} onClick={reloadPage}>
        {t('orderNew')}
      </button>
    </div>
  );
}

export default Receipt;
